import React from 'react'
import FooterStyle from './Style'
export default function Footer(): JSX.Element {
  const currentYear = new Date().getFullYear()
  return (
    <FooterStyle.FooterContainer>
      <FooterStyle.FooterContent>
        <FooterStyle.FooterCopy>
          © {currentYear} Nalapod. All rights reserved.
        </FooterStyle.FooterCopy>
        <FooterStyle.FooterSocial>
          <FooterStyle.SocialLink href="#">
            <FooterStyle.FooterFacebook />
          </FooterStyle.SocialLink>
          <FooterStyle.SocialLink>
            <FooterStyle.FooterTwitter href="#" />
          </FooterStyle.SocialLink>
        </FooterStyle.FooterSocial>
      </FooterStyle.FooterContent>
    </FooterStyle.FooterContainer>
  )
}
